import { useEffect, useState } from "react";
import { TreasureChestIcon } from "./TreasureChestIcon";
import { useNavigate } from "react-router-dom";
import { rewardsApi } from "../services/rewardsService";
import "./Rewards.css";
export function StashButton({ large = false }: { large?: boolean }) {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  useEffect(() => {
    let active = true;
    const load = async () => { try { const result = await rewardsApi.get<{count: number}>("/unread"); if(active) setCount(result.count); } catch { if(active) setCount(0); } };
    void load(); const timer = setInterval(() => { if (!document.hidden) void load(); }, 30000);
    window.addEventListener('focus', load); window.addEventListener('stash-updated', load);
    return () => { active = false; clearInterval(timer); window.removeEventListener('focus', load); window.removeEventListener('stash-updated', load); };
  }, []);
  return <button className={`stash-button${large ? ' stash-button-large' : ''}`} title="Open your Stash" aria-label={`Open your Stash${count ? `, ${count} new items` : ''}`} onClick={() => navigate('/stash')}><TreasureChestIcon size={large ? 27 : 21} />{count > 0 && <span className="stash-unread" aria-hidden="true">{count > 99 ? '99+' : count}</span>}</button>;
}
